<template>
  <div class="containerDiv">
    <PCNavbar selectIndex="contact"/>
    <MobileNavBar :currentActive="8"/>
    
    <!-- 二级菜单切换 -->
   <div class="mainbody"> 
   
    <el-row>
      <el-col :span="10" :xs="24" v-scroll-animate="'fly-in-left5gy'">
        <h1 class="h1Left">视频</h1>
         
         <!-- <video 
            :src="vedioObj.link"
            controls 
            class="videoLeft"
          ></video> -->

          <video 
            muted 
            playsinline  
            controls
            class="videoLeft"
            loop
            :src="vedioObj.link"
          ></video>

         <div class="videoInfo">
          {{ vedioObj.detail }}
          
         </div>
      </el-col>
      <el-col :span="14" :xs="24"  v-scroll-animate="'fly-in-right5gy'">
          <div class="contentR" >
            <h1>领导信箱</h1>
            <!-- <a :href="contactCenter.explains" target="_blank" > <img :src="contactCenter.photo" /> </a> -->
            <a href="/leaderEmail?type=0" > 
              <!-- <img :src="contactCenter1.photo" />  -->
              <img src="../assets/w/contact/1.png" /> 
            </a>
            
           
          </div>
          <div class="contentR" >
            <h1>交流中心</h1>
            <!-- <a :href="contactCenter.explains" target="_blank" > <img :src="contactCenter.photo" /> </a> -->
            <a href="/leaderEmail?type=1" > 
              <!-- <img :src="contactCenter.photo" />  -->
              <img src="../assets/w/contact/2.png" /> 
            </a>
           
            
          </div>
      </el-col>
    </el-row>
       

   </div>
    
  </div>
</template>

<script>
import API from '@/api/index'

import News from '@/components/news/index'

import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
  
export default {
  components: {
    PCNavbar,
    MobileNavBar,
     
    News
  },
  data() {
    return {
      vedioObj:{},
      contactCenter:{},
      contactCenter1:{},
      zhuantizhuanlan:{},
      apitest:API.leftMenuList,
      procardList: [],
      isLoading:false,
     
      
    }
  },
  mounted(){
    this.getvisionOneFn()
    this.getRotationFn(11)
    this.getRotationFn(7)
  },
  methods:{
    
    
    // 人才中心一级页面获取列表接口方法
    async getvisionOneFn() {
    try {
      let paraObj={
        catId:'14be071ad08f4819bcd0b34b75ffac60'
      }
      const res = await API.getvisionOne(paraObj)
      this.vedioObj=res.data.artList[0]
      console.log('获取成功', res.data)
    } catch (error) {
      console.error('获取失败', error)
    }
    },

     // 交流中心
     async getRotationFn(obj) {
    try {
      let paraObj={
        type:obj
      }
      const res = await API.getRotation(paraObj)
      if(obj == 11){
        this.contactCenter1=res.data.resultData[0] //领导信箱
      }else if(obj == 7){
        this.contactCenter=res.data.resultData[0] //交流中心
      }
       
      console.log('获取成功', res.data)
    } catch (error) {
      console.error('获取失败', error)
    }
    },
     
    
    
  }
 

}
</script>

<style lang="scss" scoped>
.bannerImgcss0{
  width:100%;
  // margin-top:50px;
  height:auto;
  @media (max-width: 768px) {
    margin-top:0;
  }
}
.containerDiv{
   min-width: 1000px;
   background: url('../assets/w/img3/jiaoliu/jiaoliuzhongxin-bg.png');
   background-size: 100% 100%;
  .production_card {
    width: 90vw;
    margin: 0 auto;
    background:#ffffff;
  }
} 
.mainbody{
  width: 80%;
  margin:0 auto;
  margin-top: 3.5rem;
  padding-top: 2rem;

  @media (max-width: 768px) {
      width: 100%;
      margin-top: 1rem;
  }
  
}

.h1Left{
  height: 3rem;
  line-height: 3rem;
  text-indent: 5%;
}
.videoLeft{
  width: 100%;
  height: auto;
}
.contentR{
  width: 95%;
  padding-left:5%;
  height: auto;
  h1{
    height: 3rem;
    line-height: 3rem;
  }
  // min-height: 300px;
  div{
    width: 100%;
    margin-bottom: 0.5rem;
    img{
      width: 100%;
      height: auto;
    }
  }
  img{
      width: 100%;
      height: auto;
    }
}
.videoInfo{
  background: #ffffff;
  text-indent: 2rem;
  padding: 2rem;
  font-size: 0.8rem;
  line-height: 1.8rem;
}

 
 
 
</style>